var jsonPointer = (function () {
    function jsonPointer(c, a) {
        this.d = c;
        this.dp = a;
    }
    jsonPointer.prototype.text = function () {
       
        var a = function (h) {
            var g = [];
            for (var e = 0; e < h.length; e++) {
                g.push("{" + c(h[e]) + "}");
            }
            return g.join(",");
        };
       
        var c = function (h) {
            var g = [];
            for (var e in h) {
                if (typeof h[e] == "object") {
                    if (e.length) {
                        g.push('"' + e + '":[' + a(h[e]) + "]");
                    }
                    else {
                        g.push('"' + e + '":{' + c(h[e]) + "}");
                    }
                }
                else {
                    g.push('"' + e + '":"' + h[e] + '"');
                }
            }
            return g.join(",");
        };
        return "{" + c(this.d) + "}";
    };
    jsonPointer.prototype.get = function (a) {
        return this.d[a];
    };
    jsonPointer.prototype.exists = function () {
        return !!this.d;
    };
    jsonPointer.prototype.content = function () {
        return this.d.content;
    };
    jsonPointer.prototype.each = function (g, m, l) {
        var e = this.d[g];
        var n = new jsonPointer();
        if (e) {
            for (var h = 0; h < e.length; h++) {
                n.d = e[h];
                m.apply(l, [n, h]);
            }
        }
    };
    jsonPointer.prototype.get_all = function () {
        return this.d;
    };
    jsonPointer.prototype.sub = function (a) {
        return new jsonPointer(this.d[a], this.d);
    };
    jsonPointer.prototype.sub_exists = function (a) {
        return !!this.d[a];
    };
    jsonPointer.prototype.each_x = function (g, n, m, l, h) {
        var e = this.d[g];
        var o = new jsonPointer(0, this.d);
        if (e) {
            for (h = h || 0; h < e.length; h++) {
                if (e[h][n]) {
                    o.d = e[h];
                    if (m.apply(l, [o, h]) == -1) {
                        return;
                    }
                }
            }
        }
    };
    jsonPointer.prototype.up = function (a) {
        return new jsonPointer(this.dp, this.d);
    };
    jsonPointer.prototype.set = function (a, c) {
        this.d[a] = c;
    };
    jsonPointer.prototype.clone = function (a) {
        return new jsonPointer(this.d, this.dp);
    };
    jsonPointer.prototype.through = function (e, m, r, h, s) {
        var n = this.d[e];
        if (n.length) {
            for (var g = 0; g < n.length; g++) {
                if (n[g][m] != null && n[g][m] != "" && (!r || n[g][m] == r)) {
                    var l = new jsonPointer(n[g], this.d);
                    h.apply(s, [l, g]);
                }
                var o = this.d;
                this.d = n[g];
                if (this.sub_exists(e)) {
                    this.through(e, m, r, h, s);
                }
                this.d = o;
            }
        }
    };
    return jsonPointer;
})();

export default jsonPointer;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeObject/jsonPointer.js